import Calendar20 from '@carbon/icons-react/es/calendar/20';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ClassNamePropsWithChildren } from 'components/ozone-component';

interface CalendarIconProps extends ClassNamePropsWithChildren {
  date: string;
}

const Wrapper = styled.span`
  display: flex;
  align-items: center;
`;

const Date = styled.span`
  font-size: 8px;
  font-weight: bold;
  position: absolute;
  top: 16px;
  left: 19px;
`;

export const CalendarIcon: FC<CalendarIconProps> = (props) => {
  const { date, className } = props;

  return (
    <Wrapper className={className}>
      <Date>{date}</Date>
      <Calendar20 />
    </Wrapper>
  );
};
